import { Link } from "react-router-dom";
import { Lock, X } from "lucide-react";

const COPY = {
  members_only: { t: "For members", b: "Sign in or join free as a Discovery Member to watch or listen.", cta: "Join free", to: "/join", alt: ["Sign in", "/login"] },
  ticket_required: { t: "For ticket holders", b: "This is for people with a ticket to the linked event. Already have one? Sign in.", cta: "Get tickets", to: null, alt: ["Sign in", "/login"] },
  missing: { t: "Not available", b: "This item isn't published or has moved.", cta: "Browse media", to: "/media" },
};

export const MediaGate = ({ gate, onClose }) => {
  const c = COPY[gate.code] || COPY.members_only;
  return (
    <div className="fixed inset-0 z-[120] grid place-items-center px-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-testid="media-gate">
      <div className="bg-[#F9F7F3] rounded-2xl p-8 max-w-md w-full text-center relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} aria-label="Close" data-testid="media-gate-close" className="absolute top-4 right-4 text-[#4A5D6B]"><X size={18} /></button>
        <Lock className="mx-auto text-[#144F75] mb-3" size={28} />
        <h2 className="font-serif text-2xl text-[#1A242B]" data-testid="media-gate-title">{c.t}</h2>
        <p className="text-[#4A5D6B] mt-2">{c.b}</p>
        <div className="flex justify-center gap-2 mt-6">
          <Link to={c.to || gate.event_path || "/events"} data-testid="media-gate-cta" className="eyw-btn !py-2 text-sm">{c.cta}</Link>
          {c.alt && <Link to={c.alt[1]} data-testid="media-gate-signin" className="eyw-btn-outline !py-2 text-sm">{c.alt[0]}</Link>}
        </div>
      </div>
    </div>
  );
};
